import PropTypes from 'prop-types';
import {Dimmer, Loader as LoaderComponent} from 'semantic-ui-react';

function Loader(props) {
  return (
    <Dimmer active inverted>
      <LoaderComponent>{props.content}</LoaderComponent>
    </Dimmer>
  );
}

Loader.defaultProps = {
  inverted: true,
  content: 'لطفا منتظر بمانید.'
};

Loader.propTypes = {
  inverted: PropTypes.bool.isRequired,
  content: PropTypes.string.isRequired
};


export default Loader;
